import { Socket } from 'socket.io-client'
import { CommonPipelineHandlerPayload } from '@/socket/types'

export default class PipelineSocket {
  private socket: Socket

  constructor(socket: Socket) {
    this.socket = socket
  }

  // ------------------- EMIT -------------------
  emitEnterPipeline(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('enter_pipeline', payload)
  }

  emitUpdateProjectMembers(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('update_project_members', payload)
  }

  emitUpdateLabelingMembers(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('update_labeling_members', payload)
  }

  emitDeleteProject(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('delete_project', payload)
  }

  emitDeleteClassGroup(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('delete_classGroup', payload)
  }

  emitDeleteNode(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('delete_node', payload)
  }

  emitCreateNode(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('create_node', payload)
  }

  emitUpdateNode(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('update_node', payload)
  }

  emitStartJob(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('start_job', payload)
  }

  emitPauseJob(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('pause_job', payload)
  }

  emitResumeJob(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('resume_job', payload)
  }

  emitStopJob(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('stop_job', payload)
  }

  emitCancelJob(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('cancel_job', payload)
  }

  emitCompleteJob(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('complete_job', payload)
  }

  emitStartExportModel(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('start_export_model', payload)
  }

  emitInvalidateTaskList(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('invalidate_task_list', payload)
  }

  emitLeavePipeline(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('leave_pipeline', payload)
  }

  emitFailSemiAutoLabeling(payload: CommonPipelineHandlerPayload) {
    this.socket.emit('fail_semi_auto_labeling', payload)
  }

  // ------------------- RECEIVE -------------------
  onProjectMembersUpdated(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('project_members_updated', callback)
  }

  onLabelingMembersUpdated(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('labeling_members_updated', callback)
  }

  onProjectDeleted(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('project_deleted', callback)
  }

  onClassGroupDeleted(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('classGroup_deleted', callback)
  }

  onJobStarted(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('job_started', callback)
  }

  onJobPaused(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('job_paused', callback)
  }

  onJobResumed(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('job_resumed', callback)
  }

  onJobStopped(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('job_stopped', callback)
  }

  onJobCanceled(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('job_canceled', callback)
  }

  onJobCompleted(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('job_completed', callback)
  }

  onExportModelStarted(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('export_model_started', callback)
  }

  onTaskListInvalidated(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('task_list_invalidated', callback)
  }

  onNodeDeleted(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('node_deleted', callback)
  }

  onNodeCreated(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('node_created', callback)
  }

  onNodeUpdated(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('node_updated', callback)
  }

  onSemiAutoLabelingFailed(callback: (data: CommonPipelineHandlerPayload) => void): void {
    this.socket.on('semi_auto_labeling_failed', callback)
  }
}
